import { useEffect, useRef, useState } from 'react'
import G from './globalFunction'
/**
 * 이전 값을 저장한다.
 * @param {object} value 저장하고자하는 값
 */
export const usePrevious = value => {
    const valueRef = useRef()
    useEffect(() => {
        valueRef.current = value
    }, [value])
    return valueRef.current
}

/**
 * 마우스가 이탈했을 때 숨김 function
 * @param {function}} hideFunction 숨김 function
 */
export const useHideElemOnMouseLeave = hideFunction => {
    const element = useRef()

    useEffect(() => {
        const { current } = element
        current && current.addEventListener('mouseleave', hideFunction)
        return () => current.removeEventListener('mouseleave', hideFunction)
    }, [])

    return element
}

export const useMediaSizeUpdator = () => {
    const [size, setSize] = useState(G.getMediaSize())
    useEffect(_ => {
        const updateSize = () => setSize(G.getMediaSize())
        window.addEventListener('resize', updateSize)
        updateSize()
        return () => window.removeEventListener('resize', updateSize)
    }, [])
    return size
}

export const useWindowResize = () => {
    const [size, setSize] = useState({})

    const listener = () => setSize({ width: window.innerWidth, height: window.innerHeight })

    useEffect(() => {
        window.addEventListener('resize', listener)
        listener()
        return () => {
            window.removeEventListener('resize', listener)
        }
    }, [])

    return size
}
